<div
  class="drop-area-container"
  [class.drop-area-active]="dragActive"
  (click)="fileInput.click()"
>
  <ngx-file-drop
    (onFileDrop)="dropped($event)"
    (onFileOver)="dragActive = true"
    (onFileLeave)="dragActive = false"
    [multiple]="true"
    dropZoneLabel="ჩააგდე ან აირჩიე ფაილი"
    class="drop-area"
  >
  </ngx-file-drop>

  <input
    type="file"
    #fileInput
    style="display: none"
    (change)="onFileSelected($event)"
    [multiple]="true"
    accept=".jpg,.jpeg,.png,.gif,.webp,.pdf,.doc,.docx,.txt,.xlsx,.xls,.ppt,.pptx"
  />

  <!-- <ul *ngIf="droppedFileNames.length > 0" class="mt-2">
    <li *ngFor="let name of droppedFileNames">{{ name }}</li>
  </ul> -->
</div>

<div *ngIf="uploadProgress > 0 && uploadProgress < 100" class="progress mt-2">
  <div
    class="progress-bar"
    role="progressbar"
    [style.width.%]="uploadProgress"
    [attr.aria-valuenow]="uploadProgress"
    aria-valuemin="0"
    aria-valuemax="100"
  >
    {{ uploadProgress }}%
  </div>
</div>


